import { createContext, useContext, useEffect, useState } from 'react';

const TokenContext = createContext();

export const TokenProvider = ({ children }) => {
    const [tokenData, setTokenData] = useState(null);
    const [isFirstAccess, setIsFirstAccess] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(null);

    const baseUrl = process.env.REACT_APP_API_URL;
    const accessToken = localStorage.getItem('access_token');
    const userType = localStorage.getItem('user_type');

    const checkToken = async (firstAccess = false) => {
        if (firstAccess) {
            setIsFirstAccess(true);
        }

        const endpoint = userType === 'administrador' ? '/manager/usuario/' : '/painel/usuario/';
        try {
            const response = await fetch(`${baseUrl}${endpoint}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (response.status === 200) {
                const data = await response.json();
                setTokenData(data);
                setIsAuthenticated(true);
            } else {
                localStorage.removeItem('access_token');
                setIsAuthenticated(false);
            }
        } catch (error) {
            setIsAuthenticated(false);
        }
    };

    const forceTokenCheck = (firstAccess = false) => {
        checkToken(firstAccess);
    };

    useEffect(() => {
        if (accessToken) {
            checkToken();
        } else {
            setIsAuthenticated(false);
        }
    }, [accessToken]);

    return (
        <TokenContext.Provider value={{ tokenData, isAuthenticated, checkToken, forceTokenCheck, isFirstAccess }}>
            {children}
        </TokenContext.Provider>
    );
};

export const useToken = () => useContext(TokenContext);
